import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { AlertService, FeedbackService } from '../_services/index';
import { Router } from '@angular/router';


@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  model: any = {};
  loading = false;

  constructor(private feedbackService: FeedbackService, private router: Router, private alertService: AlertService) { 

  }

  ngOnInit() {
  }

	submitFeedback() {
        this.loading = true;
		console.log("In submit button call 1")
	    this.feedbackService.create(this.model)
	        .subscribe(
	            data => {
	                this.loading = false;
	                this.alertService.success('Feedback Submitted', true);
	                this.router.navigate(['/home']);
	            },
	            error => {
	                this.loading = false;
	                this.alertService.error("Something went wrong, please try again.");
	            });

	}

}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback.component.ts